/* eslint-disable no-param-reassign */
import axios from 'axios'

const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      items: [],
      countAll: 0,
   },
   getters: {},
   actions: {
      async getData({ commit, rootState }, param) {
         rootState.isLoading = true
         // Query param datar (tanpa wrapper "filter"); nilai null diabaikan axios
         const params = {
            ...param.filter,
            search: param.search,
            page: param.page,
            perPage: param.perPage,
         }
         await axios.get(`${baseURL}oss/lkpm/non-umk`, { params }).then(
            response => {
               commit('SET_DATA', response.data.rows)
               commit('SET_COUNT', response.data.totalRecords)
               rootState.isLoading = false
            },
            () => {
               rootState.isLoading = false
            },
         )
      },
      cetak({ rootState }, id) {
         rootState.isLoading = true
         return axios
            .get(`${baseURL}oss/lkpm/non-umk/cetak/${id}`, { responseType: 'blob' })
            .then(
               response => {
                  rootState.isLoading = false
                  return Promise.resolve(response)
               },
               error => {
                  rootState.isLoading = false
                  return Promise.reject(error)
               },
            )
      },
      cetakList({ rootState }, params) {
         rootState.isLoading = true
         return axios
            .get(`${baseURL}oss/lkpm/non-umk/cetak/list`, {
               params,
               responseType: 'blob',
            })
            .then(
               response => {
                  rootState.isLoading = false
                  return Promise.resolve(response)
               },
               error => {
                  rootState.isLoading = false
                  return Promise.reject(error)
               },
            )
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.items = data
      },
      SET_COUNT(state, data) {
         state.countAll = data
      },
   },
}
